// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GiftOutlinedSvg from "@fishx/icons-svg/es/asn/GiftOutlined";
import FishxIcon from '../components/FishxIcon';

var GiftOutlined = function GiftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GiftOutlinedSvg
  }));
};

GiftOutlined.displayName = 'GiftOutlined';
export default React.forwardRef(GiftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GiftOutlined.js
// module id = 2870
// module chunks = 0